import apiClient from '../apiClient'

const bannedWords = [
    'Abuse',
    'Alcohol',
    'Animal',
    'Asphyxia',
    'Asphyxiate',
    'Asphyxiation',
    'Beastiality',
    'Bestiality',
    'Blackmail',
    'Bled',
    'Bleed',
    'Bleeding',
    'Blood',
    'Brainwash',
    'Breath Play',
    'Brutal',
    'Brutality',
    'Brutalization',
    'Bukkake',
    'Child',
    'Chloroform',
    'Choke',
    'Coerced',
    'Choking',
    'Daughter',
    'Deepfake',
    'Disgrace',
    'Drug',
    'Drugged',
    'Drugs',
    'Drunk',
    'Enema',
    'Father',
    'Fecal',
    'Fetal',
    'Foetal',
    'Force',
    'Forced',
    'Forcing',
    'Groping',
    'Helpless',
    'Hypno',
    'Hypnosis',
    'Hypnotise',
    'Hypnotize',
    'Humiliation',
    'Incapacitate',
    'Incapacitation',
    'Incest',
    'Infant',
    'Intoxicate',
    'Intoxication',
    'Involuntarily',
    'Kidnap',
    'Kill',
    'Lactate',
    'Lactation',
    'Liquor',
    'Menstrual',
    'Menstruate',
    'Molest',
    'Molestation',
    'Molested',
    'Mortification',
    'Mortify',
    'Mother',
    'Murder',
    'Mutilate',
    'Mutilation',
    'Necrophilia',
    'Pistol',
    'Passed out',
    'Paedophilia',
    'Pedophilia',
    'Poppers',
    'Puke',
    'Rape',
    'Raping',
    'Rapist',
    'Scat',
    'Sedate',
    'Sedation',
    'Sedative',
    'Sharking',
    'Shit',
    'Sleep',
    'Slumber',
    'Smother',
    'Snuff',
    'Sodomization',
    'Sodomy',
    'Suffocate',
    'Suffocation',
    'Tentacle',
    'Tequila shots',
    'Torture',
    'Unconscious',
    'Underage',
    'Unwilling',
    'Violate',
    'Violation',
    'Vomit',
]

const reportMessage = async (messageId, categories, note, attachmentUrl) => {
    try {
        const response = await apiClient.post('/moderation/reportMessage', {
            messageId,
            categories,
            note,
            attachmentUrl,
        })
        return response.data
    } catch (error) {
        console.error('Failed to report message:', error)
        throw error
    }
}

const reportGeneric = async (categories, note, email, attachmentUrl) => {
    try {
        const response = await apiClient.post(
            '/moderation/reportGeneric',
            {
                categories,
                note,
                email,
                attachmentUrl,
            },
            {
                skipAuth: true,
            }
        )
        return response.data
    } catch (error) {
        console.error('Failed to submit generic report:', error)
        throw error
    }
}

/**
 * Checks if the given text contains banned words or external links.
 * Returns the banned word or external link found, otherwise null.
 *
 * Banned words are matched as whole words (case-insensitive).
 * External links are detected using a regex for http(s) and www. patterns.
 */
const containsBannedWords = (text) => {
    if (!text || typeof text !== 'string') return null

    // 1. Check for banned words (whole word, case-insensitive)
    const bannedRegex = new RegExp(`\\b(${bannedWords.join('|')})\\b`, 'i')
    const bannedMatch = text.match(bannedRegex)
    if (bannedMatch) {
        return bannedMatch[0]
    }

    // 2. Check for external links (http(s):// or www.)
    // This regex matches URLs starting with http://, https://, or www.
    const urlRegex = /(?:https?:\/\/|www\.)[^\s]+/i
    const urlMatch = text.match(urlRegex)
    if (urlMatch) {
        return urlMatch[0]
    }

    return null
}

export default {
    reportMessage,
    reportGeneric,
    containsBannedWords,
}
